import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

// Chrome + ResizeObserver can emit a benign loop error when MUI recalculates layout.
// We suppress only that specific case so it does not surface as a runtime crash in dev.
if (
  typeof window !== "undefined" &&
  !window.__talkmateResizeObserverGuardInstalled
) {
  window.__talkmateResizeObserverGuardInstalled = true;
  window.addEventListener(
    "error",
    (event) => {
      const message =
        event?.error?.message || event?.message || String(event?.error || "");
      if (
        /ResizeObserver loop completed with undelivered notifications/i.test(
          message
        ) ||
        /ResizeObserver loop limit exceeded/i.test(message)
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
